import angular from 'angular'
import userModule from '../../user/index'
import machinesCommon from '../common'

import uiRouter from '@uirouter/angularjs/lib-esm'
import 'angular-formly'

import machinesProgressives from '../../machines.progressives'
import contract from '../../Contract'
//import { registerMachineContractDetailState } from "../../Contract/shared/components/views/machines/detail"

import ngSanitize from 'angular-sanitize'
import slotTrakUtils from '../../utils/index'

import moduleLoader from '../../utils/applicationModuleLoader/index'

import { vsModuleName as configModuleName } from "./configs/module"
import { vsModuleName as processModuleName } from "./processes/module"
import { vsModuleName as contractModuleName } from "./contracts/module"

export const vsClientName = 'desertDiamond'

var mod = angular.module('SlotTrak.Machines', [
  uiRouter,
  'angularGrid',
  slotTrakUtils,
  ngSanitize,
  'formly',
  'angular-confirm',
  userModule,
  'ui.bootstrap',
  machinesCommon,
  machinesProgressives, 
  contract,
  //registerMachineContractDetailState("main.machines.machine.contracts"),
  processModuleName,
  configModuleName,
  contractModuleName
]).constant("depreciationCalculationType", ["Straight Line", "Double Declining Balance", "Sum Of The Years Digits"])

mod.constant("clientName", vsClientName)

moduleLoader(mod, [
  require('./Pages/Edit/index'),
  require('./Pages/Main/grid/MachinesMainGridController'),
  require('./Pages/conversion/grid/index'),
  require('./Pages/conversion/grid/datasource'),
  require('./Pages/move/index'),
  require('./Server/index'),
  require('./routes'),
  require('./Pages/detail/configurations/controls/configuration/index'),
  require('./Pages/detail/configurations/controls/configurationSmall/index'),
  require('./Pages/detail/configurations/controls/configurationExpandable/index'),
  require('./Pages/detail/configurations/move/index'),
  require('./Pages/detail/configurations/configure/index'),
  require('../../ui-formly/types/contractDropDown/index'),
  //require('../../Contract/index')
])

export default mod.name